var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 8.33333,
    stroke: "#71717A",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1666 62.5C54.1666 67.1023 54.1666 70.8333 37.5 70.8333C20.8333 70.8333 20.8333 67.1023 20.8333 62.5C20.8333 57.8976 28.2952 54.1666 37.5 54.1666C46.7047 54.1666 54.1666 57.8976 54.1666 62.5Z",
    stroke: "#71717A",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 50C8.33331 34.2865 8.33331 26.4297 13.2149 21.5482C18.0964 16.6666 25.9532 16.6666 41.6666 16.6666H58.3333C74.0468 16.6666 81.9035 16.6666 86.7851 21.5482C91.6666 26.4297 91.6667 34.2865 91.6667 50C91.6667 65.7134 91.6666 73.5702 86.7851 78.4517C81.9035 83.3333 74.0468 83.3333 58.3333 83.3333H41.6666C25.9532 83.3333 18.0964 83.3333 13.2149 78.4517C8.33331 73.5702 8.33331 65.7134 8.33331 50Z",
    stroke: "#71717A",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1667 50H62.5",
    stroke: "#71717A",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1667 37.5H58.3334",
    stroke: "#71717A",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1667 62.5H66.6667",
    stroke: "#71717A",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b3ffc94bb28bfed0a6c86125bc7b9565.svg";
export { ForwardRef as ReactComponent };